import { Observable } from 'rxjs';
import { WhatsappEvent } from './types';

export abstract class IEventsRepository {
  public abstract connect(companyPhoneNumber: string): Observable<WhatsappEvent>;
}
